// import NuxtJsonld from 'nuxt-jsonld'
import LazyHydrate from "vue-lazy-hydration";

export default defineNuxtPlugin((nuxtApp) => {
  //   nuxtApp.vueApp.use(NuxtJsonld)
  nuxtApp.vueApp.component(LazyHydrate);
});
